export default {
  name: "Other Material Terms and Conditions of the Job Offer",
  prefix: "E.d",
  sections: [
    {
      fields: [
        {
          isGroup: {
            code: "E.d.1",
            machine_name: "ed1_assurance",
            label:
              "<b><u>I have read and agree</u></b> to provide the following terms and conditions with this job offer as fully explained in the Form ETA-9142-C - General Instructions and at 20 CFR 655, Subpart E.*</p><br><br><p>&#9632 <b>Three-Fourths Guarantee:</b> Workers will be offered employment for a total number of work hours equal to at least three fourths of the workdays of the total period that begins with the first workday after the arrival of the worker at the place of employment or the advertised contractual first date of need, whichever is later, and ends on the expiration date specified in the work contract or in its extensions, if any.</p><br><br><p>&#9632 <b>Transportation and Subsistence:</b> If the worker completes 50 percent of the work contract period, the employer will provide, reimburse, or advance payment for the worker's transportation and subsistence from the place of recruitment to the place of work. Upon completion of the work contract or where the worker is dismissed earlier, the employer will provide or pay for the worker's reasonable costs of return transportation and subsistence back home or to the place the worker orginally departed to work, except where the worker will not return due to subsequent employment with another employer or where the employer has appropriately reported a worker's voluntary abandonment of employment. The amount of transportation payment or reimbursement will be equal to the most economical and reasonable common carrier for the distances involved.",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
            tooltip:
              'Mark "Yes" or "No" to indicate whether the employee has read and agrees to provide each of the following terms and conditions of employment as fully explained in these <a href="https://flag.dol.gov/forms/9142Cgeneralinstructions.pdf">General Instructions</a> and at 20 CFR 655, Subpart E.',
          },
        },
      ],
    },
    {
      name: "Daily Transportation",
      fields: [
        {
          isGroup: {
            code: "E.d.2",
            machine_name: "ed2_assurance",
            label:
              "Workers will be provided with daily transportation to and from the worksite in compliance with all applicable Federal and Commonwealth laws and regulations.",
            tooltip:
              'Enter "Yes" if the employer agrees to provide workers with daily transportation to and from the worksite in accordance with applicable Federal and Commonwealth laws and regulations.  Otherwise, enter "N/A."',
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Overtime Available",
      fields: [
        {
          isGroup: {
            code: "E.d.3",
            machine_name: "ed3_assurance",
            label:
              "Overtime hours will be available to the worker under this job offer and payable for every hour worked at the rate disclosed in this application.",
            tooltip:
              'Enter "Yes" if overtime will be made available to workers.  Otherwise, enter "N/A."  The employer will keep a record of workers’ earnings and provide the workers with the required earnings statements on or before each payday, which must be at least every 2 weeks or according to the prevailing practice in the area of intended employment, whichever is more frequent.',
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "On-the-Job Training Available",
      fields: [
        {
          isGroup: {
            code: "E.d.4",
            machine_name: "ed4_assurance",
            label:
              "Workers will be provided with on-the-job training to perform the duties assigned.",
            tooltip:
              'Enter “Yes” if this position involves on-the-job training.  Otherwise, enter "N/A."',
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Employer-Provided Tools and Equipment",
      fields: [
        {
          isGroup: {
            code: "E.d.5",
            machine_name: "ed5_assurance",
            label:
              "Workers will be provided, without charge or deposit charge, all tools, supplies, and equipment required to perform the duties assigned.",
            tooltip:
              'Enter "Yes" if the employer agrees to provide to workers, without charge or deposit, all tools, supplies,and equipment required to perform the duties assigned.  Otherwise, enter "N/A."',
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Board, Lodging, or Other Facilities",
      fields: [
        {
          isGroup: {
            code: "E.d.6",
            machine_name: "ed6_assurance",
            label:
              "Workers will be provided with board, lodging, or other facilities and/or the employer will assist workers in securing board, lodging, or other facilities.",
            tooltip:
              'Enter "Yes" if the employer agrees to either provide workers with board, lodging, or other facilities and/or to assist workers in securing board, lodging, or other facilities.  Otherwise, enter "N/A."',
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Deduction From Pay",
      fields: [
        {
          code: "E.d.7",
          machine_name: "ed7_deductions",
          label:
            "State all deduction(s) from pay and, if known, the amount(s).",
          tooltip:
            'State all deduction(s) from pay not required by law and, if known, the amount(s).  If no deductions other than those requiredby law will be made from the workers’ pay, enter "N/A" or "None" in the space provided.',
          widget: "text_area",
          validate: ["required"],
          inputLimit: 1000,
          rows: 8,
        },
      ],
    },
  ],
};
